<template>
	<v-row dense>
		<v-col>
			<v-btn v-if="release" @click="emitRelease" small class="my-1">{{ $t('actions.release') }}</v-btn>
		</v-col>
		<v-spacer />
		<v-col justify="end" class="d-flex justify-end">
			<v-btn v-if="yes" @click="emitYes" text class="my-1 mr-3">{{ $t('actions.yes') }}</v-btn>
			<v-btn v-if="no" @click="emitNo" text class="my-1 mr-3">{{ $t('actions.no') }}</v-btn>
			<v-btn v-if="ok" @click="emitOk" small class="my-1 mr-3">{{ $t('actions.ok') }}</v-btn>
			<v-btn v-if="cancel" @click="emitCancel" small class="my-1 mr-3">{{ $t('actions.cancel') }}</v-btn>
			<v-btn v-if="save" @click="openSaveDialog" small class="my-1">{{ $t('actions.save') }}</v-btn>
			<v-btn v-if="close" @click="emitClose" small class="my-1 mr-3">{{ $t('actions.close') }}</v-btn>
			<yes-cancel-message-dialog
				v-model="saveDialogOpen"
				:title="$t('actions.save')"
				:message="$t('messages.saveQuestion')"
				@yes="emitSave"
			/>
		</v-col>
	</v-row>
</template>
<script>
// locals
import i18n from './dictionary';
// components
import YesCancelMessageDialog from '@/components/base/yesCancelMessageDialog/YesCancelMessageDialog.vue';

export default {
	name: 'StandardActions',
	components: { YesCancelMessageDialog },
	i18n,
	props: {
		payload: {
			required: false,
		},
		release: {
			type: Boolean,
			default: false,
		},
		yes: {
			type: Boolean,
			default: false,
		},
		no: {
			type: Boolean,
			default: false,
		},
		ok: {
			type: Boolean,
			default: false,
		},
		cancel: {
			type: Boolean,
			default: false,
		},
		save: {
			type: Boolean,
			default: false,
		},
		close: {
			type: Boolean,
			default: false,
		},
		saveDialogMayOpenHook: {
			type: Function,
			default: () => true,
		},
	},
	data() {
		return {
			saveDialogOpen: false,
			isEmitting: {
				save: false,
			},
		};
	},
	methods: {
		openSaveDialog() {
			this.saveDialogOpen = this.saveDialogMayOpenHook();
		},
		emitRelease() {
			this.$emit('release', {
				payload: this.payload,
				callback: this.openSaveDialog,
			});
		},
		emitYes() {
			this.$emit('yes');
		},
		emitOk() {
			this.$emit('ok');
		},
		emitNo() {
			this.$emit('no');
		},
		emitCancel() {
			this.$emit('cancel');
		},
		emitSave() {
			if (this.isEmitting.save) return;

			this.isEmitting.save = true;
			this.$emit('save');
			this.$nextTick(() => (this.isEmitting.save = false));
		},
		emitClose() {
			this.$emit('close');
		},
	},
};
</script>
